import fetch from 'node-fetch';
import rollbar from './rollbar';

const reserveBusiness = async (business) => {
  const path = `/api/reserveBusinessProxy`;
  const body = business;

  const response = await fetch(
    path,
    {
      method: 'POST',
      body: JSON.stringify(body)
    }
  )

  if (!response.ok) {
    const e = new Error(`${response.status} ${response.statusText}`);
    e.response = response;
    rollbar.error(e);
    throw e;
  }

  const json = await response.json();

  return {
    id: json.payload.id,
    token: json.payload.token,
  };
};

export default reserveBusiness;
